import { useState, useEffect } from "react";
import getFeature from "@template/helpers/getFeature";
import getFeatureVariables from "@template/helpers/getFeatureVariables";

const useGetExperimentVariables = ({ featureKey, variableKeys = [] }) => {
  const [variables, setVariables] = useState(
    variableKeys.reduce((acc, key) => ({ ...acc, [key]: null }), {})
  );

  useEffect(() => {
    const fetchExperimentVariables = async () => {
      const feature = await getFeature(featureKey);

      if (feature?.isEnabled()) {
        const featureVariables = await getFeatureVariables(featureKey);

        setVariables(prev =>
          variableKeys.reduce(
            (acc, key) => ({
              ...acc,
              [key]: featureVariables[key] || prev[key]
            }),
            {}
          )
        );
      }
    };

    fetchExperimentVariables();
  }, [featureKey, variableKeys]);

  return variables;
};

export default useGetExperimentVariables;
